'use client'

import React from 'react'
import Sidebar from './Sidebar'
import { useShine, type ShineConfig } from '@/shared/components'

interface SidebarWithShineProps extends ShineConfig {
  /** Decorative shine is off by default — shell uses a clean single surface. */
  shineEnabled?: boolean
}

/**
 * Sidebar wrapper. Shine overlays stay opt-in only (shell never enables them)
 * so brand/menu chrome is not doubled by animated borders.
 */
export const SidebarWithShine: React.FC<SidebarWithShineProps> = ({
  shineEnabled = false,
  ...shineConfig
}) => {
  // Never let a loose `enabled` flag from ShineConfig re-enable chrome noise
  const shine = useShine('sidebar', {
    ...shineConfig,
    enabled: shineEnabled === true,
  })

  return (
    <div style={{ position: 'relative', flexShrink: 0, height: '100%' }}>
      {shine}
      <Sidebar />
    </div>
  )
}

export default SidebarWithShine


